import { ClientProfile } from '../lib/api';
import { setActiveProfileId } from '../lib/activeProfile';
import { useActiveProfileId } from '../lib/useActiveProfile';

export function ProfilePicker({ profiles }: { profiles: ClientProfile[] }) {
  const activeId = useActiveProfileId();
  return (
    <div className="profile-picker">
      <label className="profile-picker-label" htmlFor="profile-picker-active">
        Actief profiel
      </label>
      <select
        id="profile-picker-active"
        className="full-width"
        value={activeId ?? ''}
        onChange={(event) => setActiveProfileId(event.target.value)}
      >
        {profiles.map((profile) => (
          <option key={profile.profileId} value={profile.profileId}>
            {profile.companyName}
          </option>
        ))}
      </select>
    </div>
  );
}
